import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/select';
import { Shipment } from 'src/app/shared/models/shipment';
import { ShipmentRequest } from 'src/app/shared/models/shipment-request';

@Component({
  selector: 'app-send-info-dialog',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatLabel,
    MatFormField,
    MatInput,
    MatButton,
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle
],
  templateUrl: './send-info-dialog.html',
  styleUrl: './send-info-dialog.scss',
})
export class SendInfoDialog {
  shipment = inject(MAT_DIALOG_DATA) as Shipment;
  dialogRef = inject(MatDialogRef<SendInfoDialog>);

  private readonly formBuilder = inject(FormBuilder);

  formGroup = this.formBuilder.group({
    poNumber: [this.shipment.PoNumber],
    creditNumber: [this.shipment.CreditNumber],
  });

  submitForm(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this.dialogRef.close({
      status: 'USED',
      poNumber: this.formGroup.value.poNumber ?? undefined,
      creditNumber: this.formGroup.value.creditNumber ?? undefined
    } as ShipmentRequest);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
